import { render, staticRenderFns } from "./BaseCalendar.vue?vue&type=template&id=112d4f33"
import script from "./BaseCalendar.vue?vue&type=script&lang=js"
export * from "./BaseCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports